<template>
  <div>
    <form-group :name="name" :attribute="attribute" :validator="validator">
      <template slot-scope="{ attrs }">
        <picture-input
          ref="pictureInput"
          v-bind="componentOptions"
          @change="onChange"
        />
        <div v-if="attrs.errorMessages.length > 0" class="error__text">
          {{ attrs.errorMessages[0] }}
        </div>
      </template>
    </form-group>
    <loading-dialog :show="updateLoading"></loading-dialog>
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";
import { mediaUpdate } from "@/api/globalRequest.js";
import LoadingDialog from "@/components/LoadingDialog";
export default {
  name: "PictureInputWV",
  components: {
    PictureInput,
    LoadingDialog
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    attribute: {
      type: String,
      default: ""
    },
    validator: {
      type: Object,
      default: () => {
        return {};
      }
    },
    outType: {
      type: String,
      default: "file"
    },
    options: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    componentOptions() {
      return { ...this.default_options, ...this.options };
    }
  },
  data() {
    return {
      default_options: {
        accept: "image/jpeg,image/png",
        size: 2,
        zIndex: 1,
        "button-class": "btn",
        "custom-strings": {
          drag: this.$t("message.drag"),
          change: this.$t("button.change_img"),
          remove: this.$t("button.remove_img")
        }
      },
      updateLoading: false
    };
  },
  methods: {
    onChange(image) {
      if (image) {
        if (this.outType === "file") {
          this.$emit("change", this.$refs.pictureInput.file);
        } else {
          this.$emit("change", image);
        }
      }
    },
    updateImage(id, image) {
      this.updateLoading = true;
      const formData = new FormData();
      formData.append("_method", "put");
      formData.append("locale", "en");
      formData.append("file", image);
      return new Promise((resolve, reject) => {
        mediaUpdate(id, formData)
          .then(res => {
            this.updateLoading = false;
            resolve(res.data.media);
          })
          .catch(err => {
            this.updateLoading = false;
            reject(err);
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.error__text {
  font-size: 15px;
  color: #ff5252;
  caret-color: #ff5252;
}
</style>
